import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  LinearProgress,
  SelectChangeEvent,
  CircularProgress,
} from '@mui/material';
import './TankSelect.css';
import { StorageUnit } from './embryoCulture.helpers';
import { capitalizeTitle, RequiredLabel } from '../../../utils/commonUtils';

interface CryotechSelectProps {
  cryotechs: StorageUnit[];
  selectedCryotech: number | null;
  onChange: (value: string) => void;
  label?: string;
  loading: boolean;
  hasError?: boolean;
  selectedCryotechObj:(value: StorageUnit | null) => void;
}

const CryotechSelect: React.FC<CryotechSelectProps> = ({
  cryotechs,
  selectedCryotech,
  onChange,
  label = 'Cryotech',
  loading,
  hasError = false,
  selectedCryotechObj
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const cryotechId = event.target.value;
    const selected = cryotechs.find(c => c.id === Number(cryotechId)) || null;
    selectedCryotechObj(selected);
    // eslint-disable-next-line no-console
    console.log('Selected Cryotech ID:', selected);
    onChange(cryotechId);
  };

  return (
    <FormControl
      fullWidth
      className="tank-select-container"
      error={hasError} 
    >
      <InputLabel shrink={selectedCryotech !== null}> {RequiredLabel(label, true)} </InputLabel>
      <Select
        value={selectedCryotech !== null ? String(selectedCryotech) : ''}
        onChange={handleChange}
        label={RequiredLabel(label, true)}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200, // Restricts the height of the dropdown
              overflowY: 'auto', // Enables vertical scrolling
            },
          },
        }}
        sx={{
          height: '52px',
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={20} /> &nbsp; Loading...
          </MenuItem>
        ) : cryotechs.length ? (
          cryotechs.map((cryotech) => (
            <MenuItem key={cryotech.id} value={cryotech.id} 
              disabled={cryotech.occupancy === 100} >
              <Box className="tank-item">
                <Typography className="tank-item-header"sx={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 700,
                  fontSize: '12px',
                }}>                  
                  { capitalizeTitle(cryotech.name || '')}
                  <span className="tank-progress-text">
                    {(cryotech.occupancy ?? 0).toFixed(2)}%
                  </span>
                </Typography>
                <Box className="progress-bar-container">
                  <LinearProgress
                    variant="determinate"
                    value={cryotech.occupancy ?? 0}
                    className="progress-bar"
                    sx={{
                      backgroundColor: '#e0e0e0',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: '#68B62B',
                      },
                    }}
                  />
                </Box>
              </Box>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No cryotechs available</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default CryotechSelect;
